
<template>
    <span class="framework-text" :class="{'is-error': error}" :style="styles">
        <template v-if="text">{{text}}</template>
        <template v-else>{{!isEmpty ? value : '————'}}</template>
        <slot v-if="$slots.default && !isEmpty"/>
    </span>
</template>

<script>
export default {
    name: 'v-text',
    props: {
        error: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number, Array]
        },
        dictType: {
            type: [Number, String]
        },
        params: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    watch: {
        value (val) {
            if (val) this.init()
        }
    },
    computed: {
        styles () {
            return {
                color: this.error ? 'red' : this.color,
            }
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            this.$nextTick(() => {
                this.isEmpty = this.contentIsEmpty()
                this.ready = true
            })
            if (this.dictType && this.value) {
                this.getDictType()
            }
        },
        getDictType () {
            this.$api(this.$FRAMEWORK.dictApi,{
                dictType: this.dictType,
                ...this.params
            }).then( res => {
                let index = res.findIndex(it => it.id === this.value)
                if (index !== -1) this.text = res[index].label
            }).catch(e => {
                console.error(e)
            })
        },
        contentIsEmpty () {
            if (this.value) return false
            if (this.$slots && this.$slots.default) {
                for (let i = 0; i < this.$slots.default.length; ++i) {
                    if (this.$slots.default[i].elm && this.$slots.default[i].elm.textContent) {
                        return false
                    }
                    if (this.$slots.default[i].text) {
                        return false
                    }
                }
            }
            return true
        }
    },
    data () {
        return {
            ready: false,
            isEmpty: false,
            text: ''
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/framework/widgets/text.vue